import { getEl } from "../utils.js";

/**
 * Show a toast and can fade it out.
 * @params {string | Element} elOrSelector DOM element identifier of the toast or DOM element
 * @params {string} textContent content to put inside the toast alert
 */
export function show(elOrSelector, textContent, action) {
  const el = getEl(elOrSelector);

  const clone = el.content.cloneNode(true).children[0];

  if (textContent) {
    clone.querySelector(".js-toast-content").textContent = textContent;
  }

  if (action) {
    const link = document.createElement("a");
    link.className = "button button--secondary button--sm";
    link.href = action.href;
    link.textContent = action.label;

    const wrapper = document.createElement("div");
    wrapper.className = "alert__action";
    wrapper.appendChild(link);
    clone.querySelector(".js-toast-content").appendChild(wrapper);
  }

  document.getElementById("js-toasts-receptacle").appendChild(clone);

  return clone;
}

/**
 * Show a toast with an error message from an object of errors (usually from an API response containing an Ecto Changeset errors)
 * The error object could look like this:
 *
 * {"status":false,"errors":{"type":["Ne peut être vide"],"academy_id":["Ne peut être vide"]}}
 */
export function showError(response = { errors: {} }) {
  const el = getEl("#global-error-toast");
  const clone = el.content.cloneNode(true).children[0];

  const ul = document.createElement("ul");
  Object.entries(response.errors).forEach(([key, errors]) => {
    const li = document.createElement("li");
    li.textContent = `${key}: ${errors.join(", ")}`;
    ul.appendChild(li);
  });
  clone.querySelector(".js-toast-error-details").appendChild(ul);

  document.getElementById("js-toasts-receptacle").appendChild(clone);
}

const TOAST_TEMPLATES = {
  info: "#toast-template-info",
  success: "#toast-template-success",
  error: "#toast-template-error",
};

// Listen for LiveView push_event("toast:show", ...) dispatched as phx:toast:show on window
export function initLiveViewListener() {
  window.addEventListener("phx:toast:show", (e) => {
    show(TOAST_TEMPLATES[e.detail.key], e.detail.message, e.detail.action);
  });
}

// Consume flash data serialized in the HTML by dead view layouts
export function consumeFlashData() {
  const el = document.getElementById("js-toasts-receptacle");
  if (!el?.dataset.toasts) return;

  const toasts = JSON.parse(el.dataset.toasts);
  toasts.forEach((config) => {
    show(TOAST_TEMPLATES[config.key], config.message, config.action);
  });
}

export function initForAlpine(Alpine) {
  Alpine.magic("toast", () => ({
    show,
  }));
}
